import React, { useContext, useEffect, useState } from 'react'
import { Clickable } from 'chemistry'
import { getProductCountText } from 'client/fragments/listerFragment/selectors/translations'
import { TranslateContext } from 'client/common/translator'
import { subscribeAndProcess } from 'client/common/pageBus'
import { SOFT_CONTENT_SEARCH_RENDERED } from 'client/fragments/listerFragment/components/SoftContentContainer/SoftContentContainer'
import { Skeleton, Stack } from '@chakra-ui/react'
import { useDispatch, useSelector } from 'react-redux'
import { onPageContentSwitch } from 'client/fragments/listerFragment/store/actions/pageActions'

let timeout

const stopLoadingAfterTimeout = setContentQuantity => {
  timeout = setTimeout(() => {
    setContentQuantity(-1)
  }, 3000)
}

export const ContentSwitcher = ({ productsQuantity }) => {
  const term = useSelector(store => store.data.term)
  const mode = useSelector(store => store.data.mode)
  const dispatch = useDispatch()
  const onChange = onPageContentSwitch(dispatch)

  const showJustProducts = !term
  const [contentQuantity, setContentQuantity] = useState(undefined)
  const t = useContext(TranslateContext)
  useEffect(() => {
    subscribeAndProcess('lister-fragment', SOFT_CONTENT_SEARCH_RENDERED, ({ props }) => {
      const { count } = props
      clearTimeout(timeout)
      setContentQuantity(count)
    })
    stopLoadingAfterTimeout(setContentQuantity)
  }, [])
  const handleClick = newMode => {
    onChange(newMode)
  }

  const isNoContent = contentQuantity <= 0
  if (isNoContent || showJustProducts) {
    return (
      <div className='mxd-product-count mt1' data-testid='switcher-plain-text'>
        {productsQuantity} {getProductCountText(t, productsQuantity)}
      </div>
    )
  }

  const isLoading = contentQuantity === undefined
  if (isLoading) {
    return (
      <Stack data-testid='switcher-loading'>
        <Skeleton height='45px' width='257px' />
      </Stack>
    )
  }

  return (
    <Clickable
      onClick={handleClick}
      code={mode}
      current={mode}
      entries={[
        {
          code: 'products',
          name: `${t('lister.products.multiple')} (${productsQuantity})`,
          product: { code: 'products', url: 'products' }
        },
        {
          code: 'content',
          name: `${t('lister.content')} (${contentQuantity})`,
          product: { code: 'content', url: 'content' }
        }
      ]}
    />
  )
}
